import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_4de1dc0a from 'nuxt_plugin_sentryserver_4de1dc0a' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2faf2afc from 'nuxt_plugin_sentryclient_2faf2afc' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_55867a84 from 'nuxt_plugin_plugin_55867a84' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_vuescrollto_40fb4903 from 'nuxt_plugin_vuescrollto_40fb4903' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_clipboard_4dfa12a6 from 'nuxt_plugin_clipboard_4dfa12a6' // Source: ./clipboard.js (mode: 'client')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_webfontloader_3e9d3b74 from 'nuxt_plugin_webfontloader_3e9d3b74' // Source: ./webfontloader.js (mode: 'client')
import nuxt_plugin_plugin_52fc5932 from 'nuxt_plugin_plugin_52fc5932' // Source: ./composition-api/plugin.js (mode: 'all')
import nuxt_plugin_day_caeacdb0 from 'nuxt_plugin_day_caeacdb0' // Source: ../plugins/day (mode: 'client')
import nuxt_plugin_vuegoodtable_5c195c59 from 'nuxt_plugin_vuegoodtable_5c195c59' // Source: ../plugins/vue-good-table (mode: 'client')
import nuxt_plugin_vuetify_e5914fcc from 'nuxt_plugin_vuetify_e5914fcc' // Source: ../plugins/vuetify (mode: 'client')
import nuxt_plugin_infiniteloading_70384798 from 'nuxt_plugin_infiniteloading_70384798' // Source: ../plugins/infiniteloading (mode: 'client')
import nuxt_plugin_utils_2340f33d from 'nuxt_plugin_utils_2340f33d' // Source: ../plugins/utils (mode: 'client')
import nuxt_plugin_vueobservevisibility_31cf76fe from 'nuxt_plugin_vueobservevisibility_31cf76fe' // Source: ../plugins/vue-observe-visibility (mode: 'client')
import nuxt_plugin_vuescrollto_4c33e698 from 'nuxt_plugin_vuescrollto_4c33e698' // Source: ../plugins/vue-scrollto.js (mode: 'client')
import nuxt_plugin_vsanitizehtml_4e02e904 from 'nuxt_plugin_vsanitizehtml_4e02e904' // Source: ../plugins/v-sanitize-html (mode: 'client')
import nuxt_plugin_tabsessionguardclient_71c3cd96 from 'nuxt_plugin_tabsessionguardclient_71c3cd96' // Source: ../plugins/tab-session-guard.client.ts (mode: 'client')
import nuxt_plugin_meta_3f226815 from 'nuxt_plugin_meta_3f226815' // Source: ./composition-api/meta.js (mode: 'all')
import nuxt_plugin_auth_7543862a from 'nuxt_plugin_auth_7543862a' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Big Advance","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit-cover"},{"hid":"robots","name":"robots","content":"noindex"}],"script":[{"src":"https:\u002F\u002Fyappli.io\u002Fv1\u002Fsdk.js","async":true},{"hid":"gtmHead","innerHTML":"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-NHQT5KR');"}],"noscript":[{"hid":"gtmBody","innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-NHQT5KR\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"\u003E\u003C\u002Fiframe\u003E","pbody":true}],"__dangerouslyDisableSanitizersByTagID":{"gtmHead":["innerHTML"],"gtmBody":["innerHTML"]},"htmlAttrs":{"lang":"ja"},"bodyAttrs":{"class":"rgba-stylish-light"},"link":[],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_4de1dc0a === 'function') {
    await nuxt_plugin_sentryserver_4de1dc0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_2faf2afc === 'function') {
    await nuxt_plugin_sentryclient_2faf2afc(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_55867a84 === 'function') {
    await nuxt_plugin_plugin_55867a84(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_40fb4903 === 'function') {
    await nuxt_plugin_vuescrollto_40fb4903(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clipboard_4dfa12a6 === 'function') {
    await nuxt_plugin_clipboard_4dfa12a6(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webfontloader_3e9d3b74 === 'function') {
    await nuxt_plugin_webfontloader_3e9d3b74(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_52fc5932 === 'function') {
    await nuxt_plugin_plugin_52fc5932(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_day_caeacdb0 === 'function') {
    await nuxt_plugin_day_caeacdb0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuegoodtable_5c195c59 === 'function') {
    await nuxt_plugin_vuegoodtable_5c195c59(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetify_e5914fcc === 'function') {
    await nuxt_plugin_vuetify_e5914fcc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_infiniteloading_70384798 === 'function') {
    await nuxt_plugin_infiniteloading_70384798(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_utils_2340f33d === 'function') {
    await nuxt_plugin_utils_2340f33d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueobservevisibility_31cf76fe === 'function') {
    await nuxt_plugin_vueobservevisibility_31cf76fe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_4c33e698 === 'function') {
    await nuxt_plugin_vuescrollto_4c33e698(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vsanitizehtml_4e02e904 === 'function') {
    await nuxt_plugin_vsanitizehtml_4e02e904(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tabsessionguardclient_71c3cd96 === 'function') {
    await nuxt_plugin_tabsessionguardclient_71c3cd96(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_3f226815 === 'function') {
    await nuxt_plugin_meta_3f226815(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7543862a === 'function') {
    await nuxt_plugin_auth_7543862a(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
